<div
  class="news"
  #newsContainer=""
  [class.dark]="isDark"
  [class.search-result]="isSearchResult"
  *ngIf="news"
>
  <div
    *ngIf="translatedMetadata?.picture || news.metadata!.picture"
    class="img-container"
  >
    <img
      class="img"
      [src]="translatedMetadata?.picture || news.metadata!.picture"
      alt=""
    />
  </div>

  <div class="content">
    <div class="news-bullet" *ngIf="!isPreview">
      {{
        translatedMetadata?.bullets ||
          news.metadata!.bullet ||
          news.metadata!.bullet ||
          "Author"
      }}
    </div>
    <div class="news-bullet" *ngIf="isPreview">
      {{
        translatedMetadata?.bullets ||
          news.metadata!.bullet ||
          news.metadata!.bullet ||
          "Author"
      }}
    </div>

    <p class="title" *ngIf="!isPreview">
      {{ translatedMetadata?.title || news.metadata!.title }}
    </p>
    <p class="title" *ngIf="isPreview">
      {{ translatedMetadata?.title || news.metadata!.title || "Title" }}
    </p>

    <p class="news-date" *ngIf="!isPreview">
      <mat-icon>schedule</mat-icon>
      {{ news.created_at | date : "d MMM, y" : undefined : currentLocale }}
    </p>
    <p class="news-date" *ngIf="isPreview">
      <mat-icon>schedule</mat-icon>
      <ng-container *ngIf="news.valid_from">
        {{ news.valid_from | date : "dd/MM/yyyy" }}
      </ng-container>
      <ng-container *ngIf="!news.valid_from && news.created_at">
        {{ news.created_at | date : "dd/MM/yyyy" }}
      </ng-container>
      <ng-container *ngIf="!news.valid_from && !news.created_at">
        Date
      </ng-container>
    </p>

    <ng-container *ngIf="!isDark">
      <div
        class="preview"
        *ngIf="!isPreview"
        [innerHTML]="getFirstSentence(translatedContent || news.content!)"
      ></div>
      <div
        class="preview"
        *ngIf="isPreview"
        [innerHTML]="
          getFirstSentence(translatedContent || news.content!) || 'Content'
        "
      ></div>
    </ng-container>

    <button class="read-more-btn" (click)="readMore(news)" *ngIf="!isPreview">
      {{ "Read more" | translate }}
      <mat-icon>arrow_right</mat-icon>
    </button>
  </div>
</div>
